export function switchRadioUI({ elm, attribute }) {
  const btns = document.querySelectorAll(attribute)
  btns.forEach(btn => btn.classList.remove('selected'))
  elm.classList.add('selected')
}
